import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavMenu from '../common/nav-menu/nav-menu.component';
import { Footer } from '../common/footer/footer.component';
import { navMenuActions } from '../../store/external/nav-menu-reducer/nav-menu.reducer';
import { NoSubscription } from '../external/dashboard/no-subscription/no-subscription.component';
import '../common/common-css/global.css';

class ExternalLayout extends Component {
    componentDidMount() {
        this.updateScale();
        window.addEventListener('resize', this.updateScale);

        this.observer = new MutationObserver(this.updateScale);
        this.observer.observe(document.body, { childList: true, subtree: true });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateScale);
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    updateScale = () => {
        const customBody = document.querySelector('.custom-body');
        const customModal = document.querySelector('.fade.modal.show');
        const customConfirmatonBlurModal = document.querySelector('.confirmation-blur-background');
        if (customBody) {
            let scaleFactor=0;
            if (window.innerWidth <= 1410) {
                scaleFactor = window.innerWidth / 1445;
                customBody.style.transform = 'scale(' + scaleFactor + ')';
                customBody.style.transformOrigin = 'top left';

                if (customModal) {
                    scaleFactor = window.innerWidth / 1845;
                    customModal.style.transform = 'scale(' + scaleFactor + ')';
                    customModal.style.transformOrigin = 'top left';
                }
                if(customConfirmatonBlurModal) {
                    customConfirmatonBlurModal.style.transform = 'scale(' + scaleFactor + ')';
                    customConfirmatonBlurModal.style.transformOrigin = 'top left';
                }
            } else {
                customBody.style.transform = 'none';
                if (customModal) {
                    customModal.style.transform = 'none';
                }
                if(customConfirmatonBlurModal) {
                    customConfirmatonBlurModal.style.transform = 'none';
                }
            }

            if (window.innerWidth <= 1536) {
                if (customModal) {
                    scaleFactor = window.innerWidth / 1945;
                    customModal.style.transform = 'scale(' + scaleFactor + ')';
                    customModal.style.transformOrigin = 'top left';
                }
                if(customConfirmatonBlurModal) {
                    customConfirmatonBlurModal.style.transform = 'scale(' + scaleFactor + ')';
                    customConfirmatonBlurModal.style.transformOrigin = 'top left';
                }
            }
        }
    };

    render() {  
        return (
            <div className='custom-body'>
                <NavMenu
                    isUserLoggedIn={this.props.isUserLoggedIn}
                    renderBodyAndFooter={this.renderBodyAndFooter}></NavMenu>
                {
                    this.props.newNavItems.length > 0 ? 
                    <>
                        <div className="main-wrapper">
                            {this.props.children}
                        </div>
                        <Footer/>
                    </> : 
                   <NoSubscription customClass="loading-page" title="Launching Application, Please Wait…"/>
                }
            </div>
        );
    }
}

export default connect(
    state => state.navMenu,
    dispatch => bindActionCreators(navMenuActions, dispatch),
    null,
    {
        pure: false
    }
)(ExternalLayout);
